<template>
  <v-container fluid class="mt-5">
    <v-row justify="start">
      <v-col cols="12" lg="4" md="6" sm="12">
        <v-card>
          <v-card-title>
            Tipo categoria
          </v-card-title>
          <v-card-subtitle>
            Selezionare il campo di verifica e gli sconti da applicare
          </v-card-subtitle>
          <v-card-text>
            <v-row align="center" justify="start" dense>
              <v-col>
                <v-select v-model="dati.campoVerifica" :items="campiVerifica" dense flat outlined label="Campo verifica" item-text="descrizione" item-value="codice" @input="onChangeVerifica" return-object></v-select>
              </v-col>
              <v-col>
                <v-text-field v-model="dati.scontoPercentuale" dense outlined suffix="%" label="Sconto percentuale" :rules="[rules.numero]"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field v-model="dati.scontoEuro" dense outlined suffix="€" label="Sconto euro" :rules="[rules.numero]"></v-text-field>
              </v-col>              
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4" md="6" sm="12">
        <v-card>
          <v-card-title>
            {{titoloCard}}
          </v-card-title>
          <v-card-subtitle>
            Elenco valori elementi in offerta
          </v-card-subtitle>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="(v, index) in dati.valori" :key="index">
                    <td width="80%"><v-text-field v-model="dati.valori[index]" required /></td>
                    <td><v-btn icon @click="deleteItem(v)"><v-icon>mdi-delete-outline</v-icon></v-btn></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-row align="center" justify="end" class="mt-5">
              <v-btn class="mx-3 mb-5" fab small color="primary" @click="addItem()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-btn v-if="!readOnly" class="mt-5" @click="salvaModifiche">Salva modifiche</v-btn>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Annulla</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>    
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { validazioni } from '@/mixins/validazioni.js'
  import configurazioni from '@/services/configurazioniService.js'

  export default {
    props: {
      dati: Object,
      readOnly: { type: Boolean, default: false }
    },
    mixins: [
      validazioni
    ],    
    data: (vm) => ({
      startFormatted: vm.formatDate(moment().add(-15, 'days').utcOffset(0, true).format('YYYY-MM-DD')),
      endFormatted: vm.formatDate(moment().utcOffset(0, true).format('YYYY-MM-DD')),
      start: moment().add(-15, 'days').utcOffset(0, true).format('YYYY-MM-DD'),
      end: moment().utcOffset(0, true).format('YYYY-MM-DD'),
      menuStart: false,
      menuEnd: false,
      modal: false,
      loading: false,
      orari: [],
      editedIndex: -1,
      editedItem: null,
      dialogDelete: false,
      campiVerifica: [],
      titoloCard: 'Categorie'
    }),
    created() {
    },
    async mounted() {
      this.campiVerifica = (await configurazioni.getConfigurazione('offerte', 'campiVerifica')) || []

      if (this.dati) {
        this.start = moment(this.dati.dataDa).utcOffset(0, true).format('YYYY-MM-DD')
        this.end = moment(this.dati.dataA).utcOffset(0, true).format('YYYY-MM-DD')
        this.orari = this.dati.orari || []
        this.titoloCard = _.get(this.dati, 'campoVerifica.titoloCard') || 'Categorie'
      }
    },
    computed: {
      computedStartFormatted () {
        return this.formatDate(this.start)
      },
      computedEndFormatted () {
        return this.formatDate(this.end)
      }
    },
    watch: {
      start(val) {
        this.startFormatted = this.formatDate(this.start)
      },
      end(val) {
        this.endFormatted = this.formatDate(this.end)
      },
      dati() {
        this.start = moment(this.dati.dataDa).utcOffset(0, true).format('YYYY-MM-DD'),
        this.end = moment(this.dati.dataA).utcOffset(0, true).format('YYYY-MM-DD'),
        this.orari = this.dati.orari || []
        this.titoloCard = _.get(this.dati, 'campoVerifica.titoloCard') || 'Categorie'
      }
    },
    methods: {
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      addItem() {
        this.dati.valori.push("")
      },
      deleteItem (item) {
        this.editedIndex = this.dati.valori.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.dati.valori.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = null
          this.editedIndex = -1
        })
      },
      onChangeVerifica(item) {
        this.titoloCard = item.titoloCard
      },
      salvaModifiche() {
        this.$emit('salva', this.dati)
      }
    }
  }
</script>
